import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  descriptionStyle: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    fontWeight: 'lighter',
    fontSize: 12,
  },
  informationStyle: {
    marginBottom: theme.spacing(4),
    marginLeft: theme.spacing(3),
    fontSize: 18,
  },
  titleStyle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(3),
  },
  textFieldStyle: {
    marginTop: theme.spacing(5),
  },
}))

export default useStyles
